import { render } from "./RecoverPassword.vue?vue&type=template&id=7876fbe4"
import script from "./RecoverPassword.vue?vue&type=script&lang=js"
export * from "./RecoverPassword.vue?vue&type=script&lang=js"
script.render = render

export default script